import PopUpSuccess from "./PopUpSuccess";

export default PopUpSuccess;
